import PageRoute from './[...app]';

export default PageRoute;
